// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Vetting48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Vetting48: FC<Vetting48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M33.2 19.4 21.85 30.65l-7.05-7 2.3-2.25 4.75 4.95 9.1-9 2.25 2.05Z" />
            <path
                d="M19.453 5.495c2.283-3.01 6.81-3.01 9.093 0A5.706 5.706 0 0 0 33.869 7.7c3.744-.514 6.944 2.687 6.43 6.43a5.706 5.706 0 0 0 2.205 5.323c3.01 2.283 3.01 6.81 0 9.093a5.706 5.706 0 0 0-2.205 5.323c.515 3.744-2.686 6.945-6.43 6.43a5.706 5.706 0 0 0-5.323 2.205c-2.283 3.01-6.81 3.01-9.093 0a5.706 5.706 0 0 0-5.323-2.205c-3.743.514-6.944-2.687-6.43-6.43a5.706 5.706 0 0 0-2.205-5.323c-3.01-2.283-3.01-6.81 0-9.093A5.705 5.705 0 0 0 7.7 14.13c-.514-3.743 2.687-6.944 6.43-6.43a5.705 5.705 0 0 0 5.323-2.205Zm6.702 1.814a2.706 2.706 0 0 0-4.311 0 8.706 8.706 0 0 1-8.122 3.364 2.706 2.706 0 0 0-3.05 3.049 8.706 8.706 0 0 1-3.363 8.122 2.706 2.706 0 0 0 0 4.311 8.707 8.707 0 0 1 3.364 8.123 2.706 2.706 0 0 0 3.049 3.05 8.705 8.705 0 0 1 8.122 3.363 2.706 2.706 0 0 0 4.311 0 8.707 8.707 0 0 1 8.123-3.364 2.706 2.706 0 0 0 3.05-3.049 8.707 8.707 0 0 1 3.363-8.123 2.705 2.705 0 0 0 0-4.311 8.705 8.705 0 0 1-3.364-8.122 2.706 2.706 0 0 0-3.049-3.05 8.707 8.707 0 0 1-8.123-3.363Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Vetting48;
